<template>
	<div class="page" v-loading="loadingPage" element-loading-text="加载中……">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
		</div>
		<div class="page-main">
			<el-row :gutter="20">
				<el-col :span="18">
					<el-card class="box-card" :body-style="{ padding: 0 }">
						<div slot="header" class="flex justify-between align-center">
							<div class="flex align-center">
								<span class="el-icon-document"></span>
								<span class="text-bold margin-left-sm">基础资料</span>
							</div>
							<el-button type="warning" size="small" @click="showModifyDialog">
								<i class="el-icon-edit"></i>
								<span>修改</span>
							</el-button>
						</div>
						<div class="padding padding-top-xl">
							<el-row :gutter="20">
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">姓名</div>
										<div class="con">
											<span>{{ contacterInfo.name }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">性别</div>
										<div class="con">
											<div class="cu-tag line-blue radius" v-if="contacterInfo.gender == 1">
												<i class="el-icon-male"></i>
												先生
											</div>
											<div class="cu-tag line-pink radius" v-else-if="contacterInfo.gender == 2">
												<i class="el-icon-female"></i>
												女士
											</div>
											<div class="cu-tag line-grey radius" v-else>
												<i class="el-icon-question"></i>
												未知
											</div>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">手机</div>
										<div class="con">
											<span class="">{{ contacterInfo.mobile }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">固定电话</div>
										<div class="con">
											<span class="">{{ contacterInfo.telephone }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">Email</div>
										<div class="con">
											<span class="">{{ contacterInfo.email }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">QQ</div>
										<div class="con">
											<span class="">{{ contacterInfo.qq }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="infoshow">
										<div class="title">地址</div>
										<div class="con">
											<span class="">{{ contacterInfo.address }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">微信</div>
										<div class="con">
											<span class="">{{ contacterInfo.weixin }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">添加者</div>
										<div class="con">
											<popover-user-card
												:userId="contacterInfo.adduser.user_id"
												:text="contacterInfo.adduser.name"
												:config="{ placement: 'right' }"
												v-if="contacterInfo.adduser"
											></popover-user-card>
										</div>
									</div>
								</el-col>
								<el-col :span="24">
									<div class="infoshow">
										<div class="title">备注</div>
										<div class="con">
											<span class="">{{ contacterInfo.remark }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">创建时间</div>
										<div class="con">
											<span class="">{{ contacterInfo.addtime }}</span>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="infoshow">
										<div class="title">最后更新</div>
										<div class="con">
											<span class="">{{ contacterInfo.updatetime }}</span>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</el-card>

					<el-card class="box-card margin-top" :body-style="{ padding: 0 }">
						<div slot="header" class="clearfix">
							<div class="flex justify-between align-center">
								<div class="flex align-center">
									<span class="el-icon-connection"></span>
									<span class="text-bold margin-left-sm">关联客户</span>
								</div>
								<el-button type="success" size="small" @click="dialogVisibleCheckCustomer = true">
									<i class="el-icon-plus"></i>
									<span>添加</span>
								</el-button>
								<check-customer :show="dialogVisibleCheckCustomer" @close="dialogVisibleCheckCustomer = false" @check="checkCustomer"></check-customer>
							</div>
						</div>
						<el-table
							:data="tableData.infos"
							style="width: 100%"
							stripe
							element-loading-text="加载中..."
							element-loading-spinner="el-icon-loading"
							v-loading="loadingCustomer"
						>
							<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
							<el-table-column prop="name" align="left" label="客户名称" :min-width="200">
								<template slot-scope="scope">
									<el-tooltip class="item" effect="dark" content="点击名称查看客户详情" placement="top">
										<router-link :to="'/crm/customer/view/' + scope.row.id" class="text-blue text-bold el-link el-link--primary is-underline">
											{{ scope.row.name }}
										</router-link>
									</el-tooltip>
									<div class="text-grey">{{ scope.row.credit_code }}</div>
								</template>
							</el-table-column>
							<el-table-column prop="position" align="center" label="职务"></el-table-column>
							<el-table-column prop="status" align="center" label="身份">
								<template slot-scope="scope" v-if="scope.row.status">
									<el-tag type="info" size="mini" round v-for="item in scope.row.status" :key="item" class="margin-right-xs">{{ item }}</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="stateflag" align="center" label="关联状态">
								<template slot-scope="scope">
									<el-tag type="success" size="mini" round v-if="scope.row.stateflag == 1">有效</el-tag>
									<el-tag type="info" size="mini" round v-else>无效</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="addtime" align="center" label="关联时间"></el-table-column>
						</el-table>
						<div class="padding text-right">
							<el-pagination
								background
								@size-change="pageSizeChange"
								@current-change="pageChange"
								:current-page="tableData.page"
								:page-sizes="[10, 20, 50, 100]"
								:page-size="tableData.size"
								layout="total, sizes, prev, pager, next, jumper"
								:total="tableData.total"
							></el-pagination>
						</div>
					</el-card>
				</el-col>
				<el-col :span="6">
					<el-card class="box-card" :body-style="{ padding: 0 }">
						<div slot="header" class="clearfix">
							<div class="flex justify-between align-center">
								<div class="flex align-center">
									<span class="el-icon-connection"></span>
									<span class="text-bold margin-left-sm">日志/动态</span>
								</div>
							</div>
						</div>
						<div class="margin-tb padding-tb-xs padding-right margin-right-xs" style="height: 943px; overflow-y: auto;" v-loading="loadingLog">
							<el-timeline v-if="logList.infos.length > 0">
								<el-timeline-item  :timestamp="item.time" placement="top" v-for="item in logList.infos" :key="item.id">
									<el-card>
										<div class="padding-bottom ">{{ item.content }}</div>
										<div class="flex align-center justify-between">
											<div>
												<i class="el-icon-user margin-right-xs"></i>
												<popover-user-card
													:userId="item.user.user_id"
													:text="item.user.name"
													:config="{ placement: 'right' }"
													v-if="item.user"
												></popover-user-card>
												<span class="text-grey" v-else>客户</span>
											</div>
											<div>
												<i class="el-icon-time margin-right-xs"></i>
												<span class="text-grey">{{ item.time }}</span>
											</div>
										</div>
									</el-card>
								</el-timeline-item>
							</el-timeline>
							<div class="text-center padding-sm" v-if="loadingLog">
								<i class="el-icon-refresh"></i>
								<span class="margin-left-xs">加载中……</span>
							</div>
							<div class="text-center" v-if="logList.total / logList.size > logList.page && !loadingLog">
								<el-button type="infor" @click="getLogList">
									<i class="el-icon-refresh"></i>
									<span class="margin-left-xs">加载更多</span>
								</el-button>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>

			<!-- 修改联系人信息 -->
			<el-dialog
				title="修改联系人信息"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				append-to-body
				:visible.sync="dialogVisibleModify"
				width="500px"
				:show-close="false"
				top="10vh"
			>
				<div slot="title" class="flex align-center justify-between">
					<div class="flex align-center">
						<span class="iconfont-lianxiren text-gray text-xxl"></span>
						<div class="margin-left-xs"><div class="text-bold">修改联系人信息</div></div>
					</div>
					<el-link :underline="false" type="info" @click="dialogVisibleModify = false"><i class="el-icon-close text-xxl"></i></el-link>
				</div>
				<div class="padding-right-xl" v-loading="loadingModify">
					<el-form ref="formModify" :model="formModify" label-width="80px" label-suffix=":">
						<el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请输入姓名', trigger: 'blur' }">
							<el-input v-model="formModify.name" placeholder="姓名" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="性别" prop="gender">
							<el-radio-group v-model="formModify.gender">
								<el-radio :label="1">男</el-radio>
								<el-radio :label="2">女</el-radio>
								<el-radio :label="0">未知</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="固话" prop="telephone"><el-input v-model="formModify.telephone" placeholder="固定电话" autocomplete="off"></el-input></el-form-item>
						<el-form-item label="手机" prop="mobile" :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
							<el-input v-model="formModify.mobile" placeholder="手机号码" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="email" prop="email"><el-input v-model="formModify.email" placeholder="Email 地址" autocomplete="off"></el-input></el-form-item>
						<el-form-item label="QQ" prop="qq"><el-input v-model="formModify.qq" placeholder="QQ号码" autocomplete="off"></el-input></el-form-item>
						<el-form-item label="微信" prop="weixin"><el-input v-model="formModify.weixin" placeholder="微信号码" autocomplete="off"></el-input></el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formModify.remark"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisibleModify = false">取 消</el-button>
					<el-button type="primary" @click="formSubmitModify">确 定</el-button>
				</div>
			</el-dialog>

			<!-- 绑定客户 -->
			<el-dialog
				title="关联客户"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				append-to-body
				:visible.sync="dialogVisibleBind"
				width="500px"
				:show-close="false"
				top="10vh"
			>
				<div slot="title" class="flex align-center justify-between">
					<div class="flex align-center">
						<span class="el-icon-connection text-gray text-xxl"></span>
						<div class="margin-left-xs"><div class="text-bold">关联客户</div></div>
					</div>
					<el-link :underline="false" type="info" @click="dialogVisibleBind = false"><i class="el-icon-close text-xxl"></i></el-link>
				</div>
				<div class="padding-right-xl" v-loading="loadingBind">
					<el-form ref="formBind" :model="formBind" label-width="80px" label-suffix=":">
						<el-form-item label="客户信息">
							<div class="text-bold">{{ customerInfo.name }}</div>
							<div class="text-grey" style="line-height: 20px; margin-top: -10px;">{{ customerInfo.credit_code }}</div>
						</el-form-item>
						<el-form-item label="职务" prop="position">
							<el-input v-model="formBind.position" placeholder="在该企业内的职务" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="身份" prop="status">
							<el-checkbox-group v-model="formBind.status">
								<el-checkbox label="法人"></el-checkbox>
								<el-checkbox label="股东"></el-checkbox>
								<el-checkbox label="高管"></el-checkbox>
								<el-checkbox label="财务"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="备注" prop="remark">
							<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formBind.remark"></el-input>
						</el-form-item>
						<el-form-item label="">
							<el-button type="primary" @click="formSubmitBind">确 定</el-button>
							<el-button @click="dialogVisibleBind = false">取 消</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import popoverUserCard from '@/components/popover-user-card.vue';
import checkCustomer from '@/components/check-customer.vue';

export default {
	components: { popoverUserCard, checkCustomer },
	data() {
		return {
			loadingPage: false,
			id: '',
			loadingCustomer: false,
			page: 1,
			size: 10,
			tableData: {
				page: 1,
				size: 10,
				total: 0,
				infos: []
			},
			contacterInfo: {},
			logList: {
				errmsg: '',
				page: 0,
				size: 10,
				total: 0,
				infos: []
			},
			loadingLog: false,
			previewList: [],
			formDeal: {},
			dialogVisibleModify: false,
			loadingModify: false,
			formModify: {},
			customerInfo: {},
			dialogVisibleBind: false,
			loadingBind: false,
			formBind: {
				status: []
			},
			pageData: {},
			dialogVisibleCheckCustomer: false
		};
	},
	beforecreate: function() {},
	created: function() {
		if (this.$route.params.id) {
			this.id = this.$route.params.id;
			this.getInfo();
		} else {
			this.$alert('页面参数错误！', {
				title: '操作错误',
				type: 'error',
				callback: r => {
					this.$router.back(-1);
				}
			});
			return false;
		}
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getInfo() {
			this.loadingPage = true;
			this.$http.post('/server/index.php?m=crm/contacter&a=getInfo', { id: this.id }).then(
				res => {
					this.loadingPage = false;
					if (res.result == 'ok') {
						this.contacterInfo = res.data;
						this.getCustomerInfoList();
						this.getLogList(true);
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loadingPage = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		checkCustomer(e) {
			console.log(e);
			this.dialogVisibleBind = true;
			this.customerInfo = Object.assign({}, e);
			this.formBind.id = this.id;
			this.formBind.customer = e.id;
		},
		formSubmitBind() {
			this.$refs['formBind'].validate(valid => {
				if (valid) {
					this.loadingBind = true;
					this.$http.post('/server/index.php?m=crm/contacter&a=bindCustomer', this.formBind).then(
						res => {
							this.loadingBind = false;
							if (res.result == 'ok') {
								this.$message({
									message: '关联成功',
									type: 'success'
								});
								this.dialogVisibleBind = false;
								this.getCustomerInfoList();
								this.getLogList(true);
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingBind = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				}
			});
		},
		getCustomerInfoList() {
			this.loadingCustomer = true;
			this.$http.post('/server/index.php?m=crm/contacter&a=getCustomerInfoList', { id: this.id, page: this.page, size: this.size }).then(
				res => {
					this.loadingCustomer = false;
					if (res.result == 'ok') {
						this.tableData = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loadingCustomer = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		getLogList() {
			if (arguments[0] === true) {
				this.logList.page = 0;
				this.logList.infos = [];
			}
			if (this.logList.page > 0 && this.logList.page >= Math.ceil(this.logList.total / this.logList.size)) {
				return false;
			}
			this.loadingLog = true;
			this.$http.post('/server/index.php?m=crm/contacter&a=getLogList', { id: this.id, page: this.logList.page + 1, size: this.logList.size }).then(
				res => {
					this.loadingLog = false;
					if (res.result == 'ok') {
						this.logList.errmsg = '';
						if (this.logList.infos.length == 0) {
							this.logList = res.data;
						} else {
							this.logList.page = res.data.page;
							for (let i = 0; i < res.data.infos.length; i++) {
								this.logList.infos.push(res.data.infos[i]);
							}
						}
					} else {
						this.logList.errmsg = res.msg;
					}
				},
				r => {
					this.loadingLog = false;
					this.logList.errmsg = '网络错误，指定的服务无法访问。';
				}
			);
		},
		pageChange(page) {
			this.page = page;
			this.getCustomerInfoList();
		},
		pageSizeChange(size) {
			this.size = size;
			this.getCustomerInfoList();
		},
		showModifyDialog() {
			this.formModify = Object.assign({}, this.contacterInfo);
			this.dialogVisibleModify = true;
		},
		formSubmitModify() {
			this.$refs['formModify'].validate(valid => {
				if (valid) {
					this.loadingModify = true;
					this.$http.post('/server/index.php?m=crm/contacter&a=modify', this.formModify).then(
						res => {
							this.loadingModify = false;
							if (res.result == 'ok') {
								this.$message({
									message: '修改联系人信息成功',
									type: 'success'
								});
								this.dialogVisibleModify = false;
								this.getInfo();
								this.getLogList(true);
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingModify = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					this.$alert('请根据提示填写联系人信息。', {
						title: '表单错误',
						type: 'error'
					});
				}
			});
		}
	}
};
</script>

<style>
.el-card__header {
	padding: 0 20px;
	height: 60px;
	line-height: 60px;
}
.infoshow .title {
	min-width: 180px;
}
</style>
